__turbopack_context__.v({
  "checkboxDivWrapper": "AJA3NG_checkboxDivWrapper",
});
